import { storeManager } from '@pressreader/appstore';

import { MODULE_NAME } from '../constants';

import { reducer } from './reducer';
import { saga } from './sagas';

storeManager.addFeature(MODULE_NAME, reducer, saga);

// The idempotency key itself is deliberately absent from this barrel: `setCheckoutIdempotencyKey`
// and `selectIdempotencyKey` are how the attempt mechanism keeps its own state, and a caller that
// reads or writes the key directly is a caller that has stepped around the rule deciding its
// lifetime. What a purchase surface needs is `runCheckoutAttempt`, `runCheckoutAttemptSaga` and
// `resetCheckoutAttempt` for the events that invalidate an attempt from outside.
export {
    loadSubscriptionDone,
    loadTrialEligibilityAction,
    loadTrialEligibilityBeganEvent,
    loadTrialEligibilityCancelledEvent,
    loadTrialEligibilityDoneEvent,
    loadTrialEligibilityFailedEvent,
    resetCheckoutAttempt,
} from './actions';
export { type CheckoutAttempt, runCheckoutAttempt, runCheckoutAttemptSaga } from './checkout.attempt';
export { ensureTrialEligibilityLoaded } from './sagas';
export { getTrialEligibility, selectActiveBundles, selectCurrentSubscription } from './selectors';
